import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchUserRoles = async (userId: string): Promise<RoleResponse[]> => {
	const response = await cmsClient.get<RoleResponse[]>(
		`/roles/user/${userId}/`
	);
	return response.data;
};

const useUserRoles = (userId: string) => {
	return useQuery(["user-roles", userId], () => fetchUserRoles(userId), {
		enabled: !!userId
	});
};

export default useUserRoles;
